import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const bullets = ['Querés empezar a vender iPhones y no sabés cómo conseguir clientes.', 'Ya vendés iPhones, pero dependés del boca en boca o de subir historias todos los días.', 'Tenés una tienda y recibís muchas consultas, pero pocas personas realmente compran.', 'Querés aprender a crear anuncios en Instagram y Meta Ads sin depender de una agencia.', 'Querés entender qué modelos conviene publicitar, cómo crear ofertas y cómo generar conversaciones de mejor calidad.'];
export function AudienceIntro() {
  return <section className="py-20 md:py-28 bg-white border-b border-zinc-100" data-id="element-42">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-44">
          <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 tracking-tight mb-4" data-id="element-45">
            ¿Para quién es esta guía?
          </h2>
          <p className="text-lg text-zinc-600" data-id="element-46">Esta guía es para vos si:</p>
        </motion.div>

        <motion.ul initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="space-y-4 max-w-3xl mx-auto" data-id="element-47">
          {bullets.map((item, i) => <li key={i} className="flex items-start gap-3 p-4 bg-zinc-50 rounded-xl border border-zinc-200" data-id="element-48">
              <CheckCircle2 className="w-6 h-6 text-blue-600 shrink-0 mt-0.5" data-id="element-49" />
              <span className="text-zinc-800 leading-relaxed" data-id="element-50">{item}</span>
            </li>)}
        </motion.ul>
      </div>
    </section>;
}